/**
 * Helpers to convert between a tool's stored headers_template and the form
 * model used by tool editors: a Bearer token field + custom key:value rows.
 * Keeping the split/merge in one place means editing a tool never silently
 * drops headers created via the API.
 */

export interface HeaderRow {
  key: string
  value: string
}

/** Split a stored headers_template into the Bearer token + custom header rows. */
export function splitHeadersTemplate(headersTemplate: unknown): { token: string; customHeaders: HeaderRow[] } {
  const headers = (headersTemplate || {}) as Record<string, string>
  let token = ''
  const customHeaders: HeaderRow[] = []
  for (const [key, value] of Object.entries(headers)) {
    if (key.toLowerCase() === 'authorization') {
      const v = String(value ?? '')
      token = v.startsWith('Bearer ') ? v.slice(7) : v
    } else {
      customHeaders.push({ key, value: String(value ?? '') })
    }
  }
  return { token, customHeaders }
}

/** Merge the Bearer token + custom header rows back into a headers_template. */
export function buildHeadersTemplate(token: string, customHeaders: HeaderRow[]): Record<string, string> {
  const headers: Record<string, string> = {}
  if (token.trim()) headers['Authorization'] = `Bearer ${token.trim()}`
  for (const row of customHeaders) {
    const key = row.key.trim()
    if (key && key.toLowerCase() !== 'authorization') headers[key] = row.value.trim()
  }
  return headers
}
